import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconEmailSubjectLine = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <path
          d="M13.7048 13.9875H16.0694C16.15 13.9875 16.2274 13.9555 16.2844 13.8985C16.3414 13.8415 16.3734 13.7642 16.3734 13.6836V5.30394C16.3734 5.22333 16.3414 5.14602 16.2844 5.08902C16.2274 5.03202 16.15 5 16.0694 5H3.30394C3.22333 5 3.14602 5.03202 3.08902 5.08902C3.03202 5.14602 3 5.22333 3 5.30394V13.6836C3 13.7642 3.03202 13.8415 3.08902 13.8985C3.14602 13.9555 3.22333 13.9875 3.30394 13.9875H6.1318"
          stroke="#2F393E"
          strokeWidth="0.891558"
        />
        <path
          d="M16.0832 5H3.39062C3.36573 5.0001 3.34147 5.00784 3.32111 5.02217C3.30076 5.0365 3.2853 5.05673 3.27681 5.08013C3.26833 5.10353 3.26723 5.12897 3.27367 5.15302C3.2801 5.17706 3.29377 5.19855 3.31281 5.21458L9.47307 10.4028C9.49457 10.4208 9.52162 10.4308 9.54964 10.4312C9.57767 10.4315 9.60495 10.4221 9.62687 10.4047L16.1579 5.21701C16.1777 5.20139 16.1922 5.18 16.1993 5.15581C16.2064 5.13162 16.2058 5.10581 16.1976 5.08197C16.1894 5.05813 16.1739 5.03744 16.1534 5.02275C16.1329 5.00806 16.1084 5.00011 16.0832 5Z"
          stroke="#2F393E"
          strokeWidth="0.891558"
        />
        <path
          d="M11.0101 12.0927L12.6167 13.6999C12.6544 13.7376 12.6843 13.7824 12.7048 13.8317C12.7252 13.8809 12.7357 13.9338 12.7357 13.9871C12.7357 14.0405 12.7252 14.0933 12.7048 14.1426C12.6843 14.1919 12.6544 14.2366 12.6167 14.2743L11.0101 15.881C10.9723 15.9188 10.9275 15.9487 10.8782 15.9692C10.8288 15.9896 10.7759 16.0001 10.7225 16.0001H7.56641C7.48603 16.0002 7.40745 15.9763 7.34062 15.9317C7.27379 15.887 7.22172 15.8235 7.19099 15.7493C7.16027 15.675 7.15228 15.5933 7.16803 15.5145C7.18379 15.4356 7.22257 15.3633 7.27949 15.3065L8.31106 14.2743C8.3488 14.2366 8.37873 14.1919 8.39915 14.1426C8.41957 14.0933 8.43009 14.0405 8.43009 13.9871C8.43009 13.9338 8.41957 13.8809 8.39915 13.8317C8.37873 13.7824 8.3488 13.7376 8.31106 13.6999L7.27949 12.6677C7.22257 12.611 7.18379 12.5386 7.16803 12.4598C7.15228 12.381 7.16027 12.2992 7.19099 12.225C7.22172 12.1507 7.27379 12.0872 7.34062 12.0426C7.40745 11.9979 7.48603 11.9741 7.56641 11.9741H10.7225C10.8301 11.9741 10.9335 12.0167 11.0101 12.0927Z"
          stroke="#FF9D28"
          strokeWidth="0.624091"
        />
      </SvgIcon>
    );
  })
);
